import React, { Component } from "react";

class Activate extends Component {
  state = {
    data: [],
    control: null,
    loaded: false,
  };

  constructor(props) {
    super(props);

    this.createDataList = this.createDataList.bind(this);
  }

  componentDidMount() {
    this.setState({
      control: this.props.control,
      loaded: true,
      data: this.props.data,
    });
  }

  createDataList() {
    return <div className="main-content activation">
      <div>{this.state.data[0].showActivationModal.component}</div>
    </div>;
  }

  render() {
    if (this.state.loaded) {
      return this.createDataList();
    } else {
      return "";
    }
  }
}

export default Activate;
